export const DEMO = {
  path: '/edit-page/:id',
  name: 'demo-page',
  component: require('@editor/page').default,
};

export const DEMO_REDIRECT = {
  path: '*',
  redirect: '/edit-page/demo-page',
};



// WEBPACK FOOTER //
// ./src/live-demo/routes.js